import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { playVideo } from 'widget/redux/client/actions/change-playback-status';
import { selectVideo } from 'widget/redux/client/actions/select-video';

import {
  openFullScreenOverlay,
  openFullScreenPurchaseOverlay,
  openFullScreenMemberOnlyOverlay,
} from 'shared/utils/open-overlay';


@connect(null, {
  playVideo,
  selectVideo,
})
export default class InFrameActions extends React.Component {

  static propTypes = {
    children: React.PropTypes.element.isRequired,
    selectVideo: React.PropTypes.func.isRequired,
    playVideo: React.PropTypes.func.isRequired,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
  };

  @autobind
  selectVideo() {
    const { selectVideo, videoId } = this.props;
    return selectVideo(videoId);
  }

  @autobind
  playVideo() {
    const { playVideo, videoId } = this.props;
    return playVideo(videoId);
  }

  @autobind
  showVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}`);
  }

  @autobind
  showVideoMemberOnlyInfo() {
    const { channelId, videoId } = this.props;
    return openFullScreenMemberOnlyOverlay(channelId, videoId);
  }

  @autobind
  showVideoPurchaseInfo() {
    const { channelId, videoId } = this.props;
    return openFullScreenPurchaseOverlay(channelId, videoId);
  }

  render() {
    return React.cloneElement(this.props.children, {
      onClick: this.selectVideo,
      onPlayRequest: this.selectVideo,
      onPlayMemberOnlyRequest: this.showVideoMemberOnlyInfo,
      onPlayWithoutPreviewRequest: this.showVideoAtOverlay,
      onVideoPurchaseRequest: this.showVideoPurchaseInfo,
    });
  }
}




// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/overlay-actions/in-frame.js